module.exports = __webpack_public_path__ + "images/0e16b55d4769ea81e473e6751d069d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-characters04.jpg
// module id = ./webpack/assets/img/diaryofanant-characters04.jpg
// module chunks = 0